/* eslint-disable complexity */
import { C2BSellerFinanceService } from "../../../service/c2b-seller-finance-service";
import { VehicleService } from "../../../service/vehicle-service";
import rtoCmsApi from "../../../utils/parsers/rto-cms-api";
import Types from "./types";

const setSsrStatus = (isSsr) => ({
    type: Types.SET_SSR_STATUS,
    isSsr
});

const setData = (data) => ({
    type: Types.SET_DETAILS,
    data
});

const getLandingPageData = (payload) => (dispatch) => {
    return new Promise((resolve, reject) => {
        VehicleService.getSeoContent(payload)
            .then((response) => {
                const parsedData = rtoCmsApi(response.data);
                dispatch(setData(parsedData));
                resolve(parsedData);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const sendOTP = (body) => () => {
    return new Promise((resolve, reject) => {
        C2BSellerFinanceService.sfSendOtp(body)
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

const verifyOtp = (params) => () => {
    return new Promise((resolve, reject) => {
        C2BSellerFinanceService.sfVerifyOtp(params)
            .then((response) => resolve(response.data))
            .catch((error) => reject(error));
    });
};

export { getLandingPageData, setSsrStatus, setData, sendOTP, verifyOtp };
